import styled from "styled-components";

export const ErrorMessage = styled.p`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.danger.main};
`;

export const Contador = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.neutral.neutral50};
  text-align: right;
  margin-top: 4px;
`;
